import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Heart } from 'lucide-react';

const ProductCard = ({ product }) => {
  const resolveImg = (u) => u?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
  return (
    <div className="group">
      <div className="card-img-wrap relative aspect-[4/5] rounded-xl overflow-hidden bg-[#F4E7DA]">
        <img
          src={resolveImg(product.img)}
          alt={`${product.name} - Custom corporate gift hamper by WrapYourWish`}
          width="400"
          height="500"
          loading="lazy"
          className="primary w-full h-full object-cover"
        />
        {product.img2 && (
          <img
            src={resolveImg(product.img2)}
            alt={`${product.name} detailed packaging view - WrapYourWish`}
            width="400"
            height="500"
            loading="lazy"
            className="secondary w-full h-full object-cover"
          />
        )}
        {product.tag && (
          <span className="absolute top-3 left-3 bg-white text-[#2C2416] text-[10px] uppercase tracking-widest px-3 py-1 rounded-full shadow-sm">{product.tag}</span>
        )}
        <button aria-label="Wishlist" className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/90 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#F4D5C5]">
          <Heart className="w-4 h-4 text-[#2C2416]" />
        </button>
        <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all">
          <button className="w-full btn-primary rounded-full py-2.5 text-xs uppercase tracking-widest flex items-center justify-center gap-2">
            <ShoppingBag className="w-3.5 h-3.5" /> Enquire
          </button>
        </div>
      </div>
      <div className="mt-3 px-1">
        <div className="text-[11px] uppercase tracking-widest text-[#C58B76]">{product.category}</div>
        <div className="font-serif-display text-lg text-[#2C2416] mt-1 leading-snug">{product.name}</div>
        <a href="#enquire" className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-[#7A5C4C] hover:text-[#C58B76] mt-1.5 transition-colors">
          Enquire for price →
        </a>
      </div>
    </div>
  );
};

const ProductGrid = ({ title, subtitle, products, ctaHref = '#' }) => (
  <section className="py-16 md:py-20 bg-[#FAF6F1]">
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-3">
        <div>
          <h2 className="font-serif-display text-3xl md:text-4xl text-[#2C2416]">{title}</h2>
          {subtitle && <p className="text-[#5B4A3A] mt-2 max-w-xl">{subtitle}</p>}
        </div>
        <Link to={ctaHref} className="text-xs uppercase tracking-widest text-[#7A5C4C] hover:text-[#C58B76]">View all →</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {products.map(p => <ProductCard key={p.id} product={p} />)}
      </div>
    </div>
  </section>
);

export { ProductCard };
export default ProductGrid;
